import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EmissionValueWithSuffix } from '../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { DeclaredUnit } from '../../../../../../../../../../../../shared/interfaces/IComponentDetails';
import {
  EmissionSymbol,
  IProcessDetails,
} from '../../../../../../../../../../../../shared/interfaces/IFootprint';
import styles from '../../CalculationDetails.module.css';
import TransportationDetails from '../TransportationDetails';

type TransportProcessCardProps = {
  process: IProcessDetails;
};

const TransportProcessCard = ({ process }: TransportProcessCardProps): JSX.Element | null => {
  const { t } = useTranslation();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleShowDetails = () => {
    setIsExpanded(!isExpanded);
  };
  const collapsedContent = (
    <div className='flex flex-column gap-4'>
      <div className='grid w-full grid-nogutter'>
        {/* Transportation / Route Name */}
        <div className='col-6 flex flex-column gap-1 pr-2'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.transportation.transportationRouteName')}
          </span>
          <span className='text-lg'>{process?.route_name}</span>
        </div>

        {/* Distance */}
        <div className='col-6 flex flex-column gap-1 pl-2'>
          <span className='text-gray-700 font-medium'>
            {t('calculationDetailsPage.sections.transportation.distance')}
          </span>
          <span className='text-lg flex flex-row gap-2 align-items-center'>
            {process?.route_calculation?.distance?.toFixed(1)} km
          </span>
        </div>
      </div>

      <div className='flex flex-column gap-1 w-full'>
        <span className='text-gray-700 font-medium'>
          {t('calculationDetailsPage.sections.transportation.emissions')}
        </span>

        <EmissionValueWithSuffix
          emissionValue={process?.route_calculation?.total_emissions}
          declaredUnit={DeclaredUnit.piece}
          unitaryProductAmount={1}
          emissionSymbol={EmissionSymbol.KG_CO2E}
          abbreviateUnit={true}
          emissionValueDecimals={6}
          numericalValueTextClassName='text-lg'
          suffixTextClassName='text-lg'
        />
      </div>
    </div>
  );

  const expandedContent = <TransportationDetails process={process} />;

  return (
    <div
      className={classNames('p-4 border-round-2xl flex w-full flex-column gap-5', styles['card'])}
    >
      {/* Process Name */}
      <h5 className='p-0 m-0 font-medium'>
        {t('calculationDetailsPage.sections.transportation.title')}
      </h5>
      {isExpanded ? expandedContent : collapsedContent}
      {/* Show All Details Button */}
      {
        <div className='flex w-full justify-content-center'>
          <Button
            text
            label={t(
              `calculationDetailsPage.sections.transportation.${
                isExpanded ? 'hideDetails' : 'showAllDetails'
              }`,
            )}
            className='w-fit -mt-4'
            onClick={handleShowDetails}
          />
        </div>
      }
    </div>
  );
};

export default TransportProcessCard;
